import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import {
  AVAILABILITY,
  BLOCK_OPTION, DAILY_OPTION, DISCOUNT_DETAILS,
  HOURLY_OPTION,
  MONTHLY_PRICING_DETAILS, PACKAGES
} from '../../../SpaceListingConstants';
import PackageComponent from '../../../Common/Packages';
import HourlyDiscountDetails from './HourlyPricingAndDiscounts';
import PricingAndAvailability from '../../../Common/PricingAndAvailablity';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const HourlyPricing = () => {
  const country = useSelector((state) => state?.locationMeta?.data?.country_longCode?.replace(" ", "-") || null);
  const baseRouteURL = `/${country}/dashboard/list-a-space/pricing_options/`+HOURLY_OPTION+'/';

  return (
    <>

      <Switch>

        <Route
          path={baseRouteURL + AVAILABILITY}
          component={() => {
            return <PricingAndAvailability pricingOption={HOURLY_OPTION}/>;
          }}
        />

        <Route
          path={baseRouteURL + DISCOUNT_DETAILS}
          component={() => {
            return <HourlyDiscountDetails pricingOption={HOURLY_OPTION}/>;
          }}
        />

        <Route
          path={baseRouteURL + PACKAGES}
          component={() => {
            return <PackageComponent pricingOption={HOURLY_OPTION}/>;
          }}
        />
        <Route
          path={'*'}
          component={() => <Redirect to={baseRouteURL + AVAILABILITY}/>}
        />
      </Switch>
    </>
  );
}

export default HourlyPricing;
